"use strict";

/**
 * This method doing nothing and returns `undefined`.
 */
module.exports = function () {};